var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMatchingPersonGreen = function SvgIconMatchingPersonGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.666 16.001v12a2.667 2.667 0 0 0 2.667 2.667h45.333a2.667 2.667 0 0 0 2.667-2.667v-12a2.667 2.667 0 0 0-2.667-2.666H9.333A2.667 2.667 0 0 0 6.666 16Z",
    fill: "#4CC494"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.665 27.002a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    fill: "#F9F9FA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.695 21.895a1.447 1.447 0 1 0 0-2.893 1.447 1.447 0 0 0 0 2.893ZM19.715 25.002h-4.047c-.443 0-.773-.43-.64-.853.357-1.127 1.413-1.88 2.663-1.88 1.25 0 2.307.753 2.664 1.88.133.423-.197.853-.64.853Z",
    fill: "#4CC494"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.833 20.669a1.5 1.5 0 1 0 0-3h-21a1.5 1.5 0 0 0 0 3h21ZM49.833 26.336a1.5 1.5 0 1 0 0-3h-21a1.5 1.5 0 0 0 0 3h21Z",
    fill: "#6FDCAC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.666 36v12a2.667 2.667 0 0 0 2.667 2.667h45.333A2.667 2.667 0 0 0 57.333 48V36a2.667 2.667 0 0 0-2.667-2.666H9.333A2.667 2.667 0 0 0 6.666 36Z",
    fill: "#9EEED3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.665 47.001a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    fill: "#F9F9FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.668 41.56a1.447 1.447 0 1 0 0-2.893 1.447 1.447 0 0 0 0 2.893ZM19.688 44.667h-4.046c-.444 0-.774-.43-.64-.853.356-1.127 1.413-1.88 2.663-1.88 1.25 0 2.307.753 2.663 1.88.134.423-.196.853-.64.853Z",
    fill: "#9EEED3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.833 40.668a1.5 1.5 0 0 0 0-3h-21a1.5 1.5 0 1 0 0 3h21ZM49.833 46.335a1.5 1.5 0 0 0 0-3h-21a1.5 1.5 0 1 0 0 3h21Z",
    fill: "#CFFCEC"
  })));
};
export default SvgIconMatchingPersonGreen;